<template>
    <b-container fluid class="mt-0 px-1 px-sm-3 pb-3 maintenance-page">
        <b-row>
            <b-col cols="" class="">
                <router-view />
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    name: "Safety",
    data() {
        return {
        }
    },

}
</script>